import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const SiteSubjectNotificationBarGraph = ({ subjectNotification }) => {
  const [studyOverViewDounuytChart, setStudyOverViewDounuytChart] = useState({
    series: [{ name: "No. of Notification", data: subjectNotification || [] }],
    options: {
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
      },
      stroke: { width: 1, colors: ["#fff"] },
      plotOptions: {
        bar: { horizontal: true },
      },
      xaxis: {
        categories: ["Open", "Closed"],
        labels: {
          style: {
            colors: ["#103C5E8C", "#103C5E99"],
            fontSize: "12px",
          },
        },
      },
      fill: { opacity: 1 },
      colors: ["#103C5E8C", "#103C5E99"],
      legend: {
        position: "bottom",
        showForSingleSeries: true,
      },
    },
  });

  useEffect(() => {
    setStudyOverViewDounuytChart((prevChartData) => ({
      ...prevChartData,
      series: [{ data: subjectNotification || [] }],
    }));
  }, [subjectNotification]);

  return (
    <div className="p-2">
      <ReactApexChart
        options={studyOverViewDounuytChart.options}
        series={studyOverViewDounuytChart.series}
        type="bar"
        height={200}
      />
    </div>
  );
};

export default SiteSubjectNotificationBarGraph;
